<template>
  <v-card
    class="mb-3 event-card-wrapper"
    elevation="5"
  >
    <v-card-text class="event-card">
      <div class="poster">
        <img
          :src="event.poster"
          alt=""
        />
      </div>
      <div class="event-description">
        <a :href="'/event/' + event.id + '?h=0'">
          <h2>{{ event.name }}</h2>
        </a>
        <p
          v-if="event.subtitle"
          class="subtitle"
        >
          {{ event.subtitle }}
        </p>
        <div
          class="description-wrapper"
          :class="{ 'always-visible': alwaysShowDescription }"
        >
          <div v-html="description"></div>
          <div v-if="allowTextShortening">
            <button
              v-if="!showDescription"
              @click="showDescription = true"
              class="read-more"
            >
              Прочети повече
            </button>
            <button
              v-else
              @click="showDescription = false"
              class="read-more"
            >
              Скрий
            </button>
          </div>
        </div>
      </div>
      <v-row class="details-wrapper">
        <v-col>
          <div class="detail-row">
            <div class="icon"><v-icon small>event</v-icon></div>
            <div class="details">
              {{ eventDate }}
            </div>
          </div>
          <div class="detail-row">
            <div class="icon"><v-icon small>schedule</v-icon></div>
            <div class="details">
              {{ eventTime }}
            </div>
          </div>
          <div class="detail-row">
            <div class="icon"><v-icon small>local_activity</v-icon></div>
            <div class="details">
              {{ event.event_details ? event.event_details.price_range : '-' }}
            </div>
          </div>
        </v-col>
        <v-col>
          <div class="detail-row">
            <div class="icon"></div>
            <div
              class="details text-uppercase"
              v-if="event.address_link"
            >
              <a :href="event.address_link">{{ event.address }}</a>
            </div>
            <div
              class="details text-uppercase"
              v-else
            >
              {{ event.address }}
            </div>
          </div>
          <div class="detail-row">
            <div class="icon"><v-icon small>place</v-icon></div>
            <div
              class="details"
              v-if="event.address_link"
            >
              <a :href="event.address_link">
                {{
                  event.event_details
                    ? event.event_details.address_line_1
                    : event.address_line_two.substring(0, 25)
                }}
              </a>
            </div>
            <div
              class="details text-uppercase"
              v-else
            >
              {{ event.address }}
            </div>
          </div>
          <div class="detail-row">
            <div class="icon"></div>
            <div
              class="details"
              v-if="event.address_link"
            >
              <a :href="event.address_link">
                {{
                  event.event_details ? event.event_details.address_line_2 : ''
                }}
              </a>
            </div>
            <div
              class="details text-uppercase"
              v-else
            >
              {{
                event.event_details ? event.event_details.address_line_2 : ''
              }}
            </div>
          </div>
        </v-col>
        <v-col>
          <div class="detail-row">
            <div class="icon"></div>
            <div class="details">
              {{ event.event_details ? event.event_details.details[0] : '' }}
            </div>
          </div>
          <div class="detail-row">
            <div class="icon"><v-icon small>info</v-icon></div>
            <div class="details">
              {{ event.event_details ? event.event_details.details[1] : '' }}
            </div>
          </div>
          <div class="detail-row">
            <div class="icon"></div>
            <div class="details">
              {{ event.event_details ? event.event_details.details[2] : '' }}
            </div>
          </div>
        </v-col>
      </v-row>
      <div
        class="button-wrapper"
        v-if="showBuyTicketsBtn"
      >
        <v-btn
          color="primary"
          :href="'/event/' + event.id + '?h=0'"
        >
          Купи Билети
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
export default {
  name: 'EventCard',
  props: {
    event: {
      type: Object,
      required: true,
    },
    alwaysShowDescription: {
      type: Boolean,
      default: false,
    },
    showBuyTicketsBtn: {
      type: Boolean,
      default: true,
    },
    shortText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    eventDate() {
      return moment(this.event.date).format('DD.MM.YYYY')
    },
    eventTime() {
      return moment(this.event.time, 'HH:mm:ss').format('H:mm')
    },
    description() {
      if (this.shortText && this.event.description.length > 350) {
        return `${this.event.description.substring(0, 350)}...`
      }

      if (this.allowTextShortening && !this.showDescription) {
        return `${this.event.description.substring(0, 100)}...`
      }

      return this.event.description
    },
    allowTextShortening() {
      return window.innerWidth < 800 && this.event.description.length > 100
    },
  },
  data() {
    return {
      showDescription: false,
    }
  },
}
</script>

<style
  lang="scss"
  scoped
>
.event-card {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 20px;
  //background: #faf8ff;

  .poster {
    img {
      width: 100%;
    }
  }

  .address-row,
  .detail-row {
    display: flex;

    .address-icon,
    .icon {
      display: flex;
      width: 30px;
    }

    .details {
      font-weight: bold;
    }
  }

  .button-wrapper {
    grid-column-start: 1;
    grid-column-end: 3;
    display: flex;
    justify-content: center;

    .v-btn {
      max-width: 300px;
      width: 100%;
    }
  }

  .details-wrapper {
    grid-column-start: 1;
    grid-column-end: 3;
    display: flex;
    justify-content: center;
  }

  h2 {
    color: #1a76d2;
    font-size: 18px;
  }

  p {
    font-size: 14px;
  }

  .subtitle {
    font-weight: bold;
  }

  .read-more {
    margin: 0px 0 10px 0;
    text-transform: uppercase;
    font-size: 13px;
    font-weight: bold;
    color: black;
    outline: none;
  }
}

@media (max-width: 480px) {
  .description-wrapper:not(.always-visible) {
    display: none;
  }
}

.detail-row a {
  color: rgba(0, 0, 0, 0.6);
}
</style>
